import { SEC_DataApiPost } from '../func';

/** Calls the protected Forms administration endpoint and validates its response. */
async function postFormsAdmin(payload) {
    const response = await SEC_DataApiPost('forms/manage', JSON.stringify(payload), {});
    if (!response || typeof response !== 'object' || response.message) {
        throw new Error(response?.message || 'Unexpected Forms API response.');
    }
    return response;
}

/** Loads form definitions and active staff for Forms administration. */
export function getSystemFormsBootstrap(scope = 'assigned') {
    return postFormsAdmin({ operation: 'bootstrap', scope });
}

/** Creates one validated form definition in System Options. */
export function createSystemForm(form) {
    return postFormsAdmin({ operation: 'create', form });
}

/** Updates one existing form definition and its assigned access. */
export function updateSystemForm(formId, form) {
    return postFormsAdmin({ operation: 'update', formId, form });
}

/** Archives one form while preserving its responses, files and administrator access. */
export function archiveSystemForm(formId) {
    return postFormsAdmin({ operation: 'archive', formId });
}

/** Restores one archived form and reapplies its saved completion access. */
export function restoreSystemForm(formId) {
    return postFormsAdmin({ operation: 'restore', formId });
}

/** Updates one Forms permission controlled by a school-wide System Manager. */
export function updateFormsUserAccess(targetCogId, permissionName, enabled) {
    return SEC_DataApiPost('sysmanager/forms/create-access', JSON.stringify({
        targetCogId,
        permissionName,
        enabled: Boolean(enabled),
    }), {}).then((response) => {
        if (!response || typeof response !== 'object' || response.message
            || typeof response.formsAccess !== 'boolean'
            || typeof response.canCreateForms !== 'boolean') {
            throw new Error(response?.message || 'Unexpected Forms access API response.');
        }
        return response;
    });
}
